(() => {
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const initialized = new WeakSet();
  const mediaPresent = element => Boolean(element.querySelector('img,video'));
  const once = (root, selector, callback) => root.querySelectorAll(selector).forEach(element => {
    if (initialized.has(element)) return;
    initialized.add(element);
    callback(element);
  });
  const initialize = (root = document) => {
    root.querySelectorAll('.wf-ig-slide,.wf-vtr-tile,.wf-bac-half,.wf-dl-thumb,.wf-fs-media,.wf-ppan,.wf-mbnd').forEach(frame => {
      if (mediaPresent(frame)) return;
      const parent = frame.parentElement;
      frame.remove();
      // A media-only grid column should not leave an empty column behind.
      if (parent?.parentElement?.className.includes('wf-grid-') && !parent.textContent.trim() && !parent.querySelector('img,video,svg')) parent.remove();
    });
    root.querySelectorAll('[class*="wf-grid-"]').forEach(grid => {
      if (grid.children.length === 1) grid.style.gridTemplateColumns = 'minmax(0,1fr)';
    });
    once(root, '.wf-ig', gallery => {
      const viewport = gallery.querySelector('.wf-ig-view');
      const slides = [...gallery.querySelectorAll('.wf-ig-slide')];
      const previous = gallery.querySelector('.wf-ig-prev');
      const next = gallery.querySelector('.wf-ig-next');
      if (!slides.length) { gallery.hidden = true; return; }
      previous.hidden = next.hidden = slides.length < 2;
      let index = 0;
      const update = () => {
        index = Math.round(viewport.scrollLeft / (viewport.clientWidth || 1));
        previous.disabled = index === 0;
        next.disabled = index >= slides.length - 1;
      };
      const go = delta => {
        const target = Math.max(0, Math.min(slides.length - 1, index + delta));
        viewport.scrollTo({left: target * viewport.clientWidth, behavior});
      };
      previous.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      viewport.addEventListener('scroll', update, {passive: true});
      viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); go(event.key === 'ArrowLeft' ? -1 : 1); }
      });
      update();
    });
    once(root, '.wf-bac', carousel => {
      const track = carousel.querySelector('.wf-bac-track');
      const original = [...carousel.querySelectorAll('.wf-bac-slide')];
      const picks = [...carousel.querySelectorAll('.wf-bac-pick')];
      const slides = original.filter(mediaPresent);
      const pickers = [];
      picks.forEach((picker, i) => {
        const newIndex = slides.indexOf(original[i % original.length]);
        if (newIndex < 0) { picker.remove(); return; }
        // A removed avatar leaves the dog's name available as the picker.
        pickers.push({picker, index: newIndex});
      });
      original.filter(slide => !mediaPresent(slide)).forEach(slide => slide.remove());
      const previous = carousel.querySelector('.wf-bac-prev');
      const next = carousel.querySelector('.wf-bac-next');
      previous.hidden = next.hidden = slides.length < 2;
      if (!slides.length) { carousel.querySelector('.wf-bac-media').hidden = true; return; }
      let index = 0;
      const show = nextIndex => {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        slides.forEach((slide, i) => { slide.setAttribute('aria-hidden', String(i !== index)); slide.inert = i !== index; });
        pickers.forEach(({picker, index: pickIndex}) => {
          const selected = pickIndex === index;
          picker.setAttribute('aria-current', String(selected));
          const face = picker.querySelector('.wf-bac-face');
          if (face) face.dataset.active = String(selected);
        });
      };
      pickers.forEach(({picker, index}) => picker.addEventListener('click', () => show(index)));
      previous.addEventListener('click', () => show(index - 1));
      next.addEventListener('click', () => show(index + 1));
      show(0);
    });
    once(root, '.wf-tc', carousel => {
      const viewport = carousel.querySelector('.wf-tc-track').parentElement;
      viewport.style.overflowX = 'auto';
      viewport.style.scrollbarWidth = 'none';
      carousel.querySelectorAll('.wf-tc-btn').forEach((button, index) => button.addEventListener('click', () => {
        viewport.scrollBy({left: (index === 0 ? -1 : 1) * viewport.clientWidth, behavior});
      }));
    });
  };
  let stickySizeObserver;
  const initializeSticky = () => {
    stickySizeObserver?.disconnect();
    const sticky = document.querySelector('.wf-promo-fixed');
    if (!sticky) return;
    sticky.style.visibility = 'visible';
    sticky.inert = false;
    sticky.setAttribute('aria-hidden', 'false');
    const spacer = document.querySelector('.wf-promo-sticky:not(.wf-promo-fixed)');
    if (!spacer) return;
    const updateSpace = () => {
      spacer.style.boxSizing = 'border-box';
      spacer.style.height = `${Math.ceil(sticky.getBoundingClientRect().height)}px`;
    };
    updateSpace();
    stickySizeObserver = new ResizeObserver(updateSpace);
    stickySizeObserver.observe(sticky);
  };
  initialize();
  initializeSticky();
  document.addEventListener('shopify:section:load', event => { initialize(event.target); initializeSticky(); });
  document.addEventListener('shopify:section:unload', () => { queueMicrotask(initializeSticky); });
  document.addEventListener('shopify:block:select', event => {
    const media = event.target.closest('.mrw-media');
    const offer = media?.closest('mwf-offer');
    if (offer) {
      const slot = media.dataset.mediaSlot;
      const index = offer.slides.findIndex(slide => slide.querySelector(`[data-media-slot="${CSS.escape(slot)}"]`));
      if (index >= 0) offer.showSlide(index);
    }
  });
})();
